import * as Yup from "yup";
import { stringRegex } from "../../../../utils/FormUtil";
import { getDifferenceInYears } from "../../../../utils/DateUtil";

const petFormModel = {
  valuesForm: {
    first_name: "",
    race: null,
    customRace: "",
    specie: null,
    size: { value: "MEDIUM", name: "10-20 kg. Mediano" },
    weight: "",
    height: "",
    age: 0,
    changePhotoAttempts: 2,
    sex_str: "",
    castrated_str: "",
    birth_date: "",
    furColor: "",
    allergies: "",
    allergies_check_box: "false",
    frequent_medication_check_box: "false",
    frequent_medication: [],
    pre_existing_disease: [],
    surgeries: [],
    urlPuppy: null,
    urlAdult: null,
    imagePuppy: null,
    imageAdult: null,
    healthBooklet: [],
    medicalStudies: [],
    vaccines: {},
  },

  first_name: {
    name: "first_name",
    label: "Nombre",
    stringErrorMsg: "Ingresa sólo letras",
    requiredErrorMsg: "El nombre es requerido",
  },
  race: {
    name: "race",
    label: "Raza",
    requiredErrorMsg: "La raza es requerida",
  },
  customRace: {
    name: "customRace",
    label: "Escribe la raza",
    requiredErrorMsg: "La raza es requerida",
  },
  specie: {
    name: "specie",
    label: "Especie",
    requiredErrorMsg: "La especie es requerida",
  },
  furColor: {
    name: "furColor",
    label: "Color de Pelaje",
    requiredErrorMsg: "El color de pelaje es requerido",
  },
  size: {
    name: "size",
    label: "Tamaño",
    requiredErrorMsg: "El tamaño es requerido",
  },
  weight: {
    name: "weight",
    label: "Peso",
    requiredErrorMsg: "El peso es requerido",
  },
  age: {
    name: "age",
    label: "Edad",
    requiredErrorMsg: "La edad es requerida",
  },
  height: {
    name: "height",
    label: "Altura",
    requiredErrorMsg: "La altura es requerida",
  },
  allergies: {
    name: "allergies",
    label: "Alergia",
    requiredErrorMsg: "La alergia es requerida",
  },
  allergies_check_box: {
    name: "allergies_check_box",
    label: "Alergia",
    requiredErrorMsg: "La alergia es requerida",
  },
  frequent_medication: {
    name: "frequent_medication",
    label: "Medicación Frecuente",
    placeholder: "Selecciona una medicación frecuente",
    requiredErrorMsg: "La medicación frecuente es requerida",
    searchTextLabel: "Ingrese una medicación frecuente",
    searchTextMinRequired: "Ingrese al menos 3 caracteres",
  },
  frequent_medication_check_box: {
    name: "frequent_medication_check_box",
    label: "Medicación Frecuente",
    requiredErrorMsg: "La medicación frecuente es requerida",
  },
  last_name: {
    name: "last_name",
    label: "Apellido",
    requiredErrorMsg: "El apellido es requerido",
  },
  id_number: {
    name: "id_number",
    label: "DNI",
    minErrorMsg: "Ingresa un DNI válido",
    maxErrorMsg: "Ingresa un DNI válido",
    requiredErrorMsg: "El DNI es requerido",
  },
  birth_date: {
    name: "birth_date",
    label: "Fecha de Nacimiento",
    minDate: "1900/01/01",
    minAgeErrorMsg: "Debe ser mayor a 1 año",
    requiredErrorMsg: "La fecha de nacimiento es requerida",
  },
  phone_number: {
    name: "phone_number",
    label: "Teléfono",
    minErrorMsg:
      "Ingresa un teléfono válido. Escribe el código de área sin 0 y el número sin 15. Ej. 1123456789",
    maxErrorMsg:
      "Ingresa un teléfono válido. Escribe el código de área sin 0 y el número sin 15. Ej. 1123456789",
    requiredErrorMsg: "El teléfono es requerido",
    extraLabel: "Código de área sin 0 y el número sin 15. Ej. 1123456789",
  },
  sex_str: {
    name: "sex_str",
    label: "Sexo",
    requiredErrorMsg: "El sexo es requerido",
    extraLabel: "Como figura en DNI",
  },
  castrated_str: {
    name: "castrated_str",
    label: "Castrado",
    requiredErrorMsg: "Esta castrado es requerido",
    extraLabel: "Como figura en DNI",
  },
  relationship_to_titular: {
    name: "relationship_to_titular",
    label: "Relación con el titular",
    requiredErrorMsg: "La relación es requerida",
  },
  address_dto: {
    street: {
      name: "address_dto.street",
      label: "Calle",
      requiredErrorMsg: "La calle es requerida",
    },
    number: {
      name: "address_dto.number",
      label: "Número",
      minErrorMsg: "Ingresa un número válido",
      maxErrorMsg: "Ingresa un número válido",
      requiredErrorMsg: "El número es requerido",
    },
    number_department: {
      name: "address_dto.number_department",
      label: "Distrito/Barrio",
    },
    floor: {
      name: "address_dto.floor",
      label: "Piso/Depto",
    },
    postal_code: {
      name: "address_dto.postal_code",
      label: "CP",
      minErrorMsg: "Ingresa un CP válido",
      maxErrorMsg: "Ingresa un CP válido",
      requiredErrorMsg: "El CP es requerido",
    },
    between_streets: {
      name: "address_dto.between_streets",
      label: "Entre calles",
      minErrorMsg: "Ingresa un dato válido",
      maxErrorMsg: "Ingresa un dato válido",
    },
    city: {
      name: "address_dto.city",
      label: "Ciudad",
      minErrorMsg: "Ingresa una ciudad válida",
      maxErrorMsg: "Ingresa una ciudad válida",
      requiredErrorMsg: "La ciudad es requerida",
    },
    country: {
      name: "address_dto.country",
      label: "País",
      requiredErrorMsg: "El país es requerido",
    },
    province: {
      name: "address_dto.province",
      label: "Provincia o Estado",
      minErrorMsg: "Ingresa una provincia válida",
      maxErrorMsg: "Ingresa una provincia válida",
      requiredErrorMsg: "La provincia o estado es requerido",
    },
  },
  pre_existing_disease: {
    name: "pre_existing_disease",
    label: "Enfermedades Preexistentes",
    placeholder: "Selecciona una o más enfermedades preexistentes",
  },
  surgeries: {
    name: "surgeries",
    label: "Cirugías",
    placeholder: "Selecciona una o más cirugías",
  },
  patient_dto: {
    pre_existing_disease: {
      name: "patient_dto.pre_existing_disease",
      label: "Enfermedades Preexistentes",
      placeholder: "Selecciona una o más enfermedades preexistentes",
    },
    frequent_medication: {
      name: "patient_dto.frequent_medication",
      label: "Medicaciones Frecuentes",
      searchTextLabel: "Ingrese una medicación frecuente",
      searchTextMinRequired: "Ingrese al menos 3 caracteres",
    },
    surgeries: {
      name: "patient_dto.surgeries",
      label: "Cirugías",
      placeholder: "Selecciona una o más cirugías",
    },
    size: {
      name: "patient_dto.size",
      label: "Altura",
      requiredErrorMsg: "La altura es requerida",
    },
    weight: {
      name: "patient_dto.weight",
      label: "Peso",
      requiredErrorMsg: "El peso es requerido",
    },
    allergies: {
      name: "patient_dto.allergies",
      label: "Alergias",
    },
    family_history: {
      name: "patient_dto.family_history",
      label: "Antecedentes Familiares",
    },
    vaccines: {
      name: "patient_dto.vaccines",
      label: "Vacunas",
    },
    gynecological_data: {
      name: "patient_dto.gynecological_data",
      label: "Ginecológicos y Obstétricos",
    },
    patientAge: {
      name: "patient_dto.age",
      label: "Edad",
    },
    attention_type: {
      name: "patient_dto.attention_type",
      label: "Tipo de Atención",
      requiredErrorMsg: "El tipo de atención es requerido",
    },
    affiliate_number: {
      name: "patient_dto.affiliate_number",
      label: "N° de asociado",
      requiredErrorMsg: "El número de asociado es requerido",
    },
    patientStudy: {
      name: "patient_dto.study",
      label: "Adjuntar Estudios Médicos",
    },
  },
};

export default petFormModel;

const stringErrorMsg = "Ingresa sólo letras";
const typeDateErrorMsg = "Ingresa una fecha válida";

export const petFormValidation = [
  Yup.object().shape({
    first_name: Yup.string()
      .matches(stringRegex, stringErrorMsg)
      .required(petFormModel.first_name.requiredErrorMsg),
    sex_str: Yup.string().required(petFormModel.sex_str.requiredErrorMsg),
    castrated_str: Yup.string().required(
      petFormModel.castrated_str.requiredErrorMsg
    ),
    race: Yup.object().required(petFormModel.race.requiredErrorMsg),
    customRace: Yup.string().when("race", (raceVal, schema) => {
      if (raceVal?.race === "Otro") {
        return schema.required("Por favor especifique la raza.");
      }
      return schema.notRequired();
    }),
    specie: Yup.object().required(petFormModel.specie.requiredErrorMsg),
    furColor: Yup.string().required(petFormModel.furColor.requiredErrorMsg),
    size: Yup.object().required(petFormModel.size.requiredErrorMsg),
    birth_date: Yup.date()
      .typeError(typeDateErrorMsg)
      .required(petFormModel.birth_date.requiredErrorMsg),
  }),
];
